var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 20.75L8.75 14.75H0.75L2.75 20.75H10.75ZM10.75 20.75H14.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 11.75V11.25C10.75 9.3644 10.75 8.42157 10.1642 7.83579C9.5784 7.25 8.63562 7.25 6.75 7.25C4.86438 7.25 3.92157 7.25 3.33579 7.83579C2.75 8.42157 2.75 9.3644 2.75 11.25V11.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 11.75C17.75 12.8546 16.8546 13.75 15.75 13.75C14.6454 13.75 13.75 12.8546 13.75 11.75C13.75 10.6454 14.6454 9.75 15.75 9.75C16.8546 9.75 17.75 10.6454 17.75 11.75Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.75C8.75 3.85457 7.85457 4.75 6.75 4.75C5.64543 4.75 4.75 3.85457 4.75 2.75C4.75 1.64543 5.64543 0.75 6.75 0.75C7.85457 0.75 8.75 1.64543 8.75 2.75Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 16.25H18.75C19.8546 16.25 20.75 17.1454 20.75 18.25V18.75C20.75 19.8546 19.8546 20.75 18.75 20.75H17.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.cbfd379392849da6570d8ffbd19bffc8.svg";
export { ForwardRef as ReactComponent };